import Screen from './screen';
import template from './templates/tnps.html';
import { resizeContentHeight, getContentHeight } from "../../utils/resizeContentHeight";
import { LoadingElement } from './loadingElement';
import { ScreenChangeNotice } from '../../customNotice/clientNotice/screenChangeNotice';
import { TNPSSurvey } from '../../utils/tnpsSurvey';
import { TrackingNotice } from '../../customNotice/botNotice/trackingNotice';
import { ConfigurationManager } from '../../utils/configurationManager';
export class TNPSScreen extends Screen {
    constructor(uic) {
        super("tnps", uic);
        this.reset = () => {
            $('input[name="cbot-feedback-radioG"]').attr("checked", false);
            $('input[name="cbot-feedback-radioG"]+label').removeClass('unchecked');
            this.elements['tnpsFeedbackArea'].attr("readonly", true);
            this.elements['tnpsFeedbackArea'].val('');
            this.elements['tnpsFeedbackArea'].addClass('is-empty');
            this.elements['tnpsFeedbackArea'].removeClass('animate');
            this.elements['tnpsPrompt'].show();
            this.elements['tnpsSendButton'].show();
            this.elements['tnpsSendButton'].attr("disabled", true);
            if (ConfigurationManager.getValueIfExists(this.uic.configuration, 'surveySettings.alwaysShowReasonField')) {
                this.showFeedbackArea(false);
            }
            else {
                this.hideFeedbackArea();
            }
        };
        this.resizeHeight = () => {
            resizeContentHeight(this.elements['widgetWindow'], this.elements['tnpsContentContainer']);
            let chatWindowHeight = $('.cbot-chatWindow').height();
            let nonContentHeight = getContentHeight(this.elements['widgetWindow']);
            let contentHeight = 0;
            this.elements['tnpsContentContainer'].find('.content').each((index, element) => {
                let jqe = $(element);
                if (jqe.is(':visible')) {
                    contentHeight += jqe.outerHeight();
                    contentHeight += parseInt(jqe.css("margin-top")) > 0 ? parseInt(jqe.css("margin-top")) : 0;
                    contentHeight += parseInt(jqe.css("margin-bottom")) > 0 ? parseInt(jqe.css("margin-bottom")) : 0;
                }
            });
            let space = chatWindowHeight - nonContentHeight - contentHeight;
            if (space < 0) {
                space = 0;
            }
            space /= 2;
            $('#cbot-feedback-tnps-space-top').css('height', space + "px");
            $('#cbot-feedback-tnps-space-bottom').css('height', space + "px");
        };
        this.sendAnalyticsEvent = (score, text, helpful, dismissed, displayed, error) => {
            let event = TNPSSurvey.createCustomNoticeEvent(score, text, helpful, dismissed, displayed, error);
            this.uic.widget.sendCustomNotice(event);
        };
        this.elements = {};
    }
    show(options) {
        if (options) {
            this.initTNPSSurvey(options);
        }
        this.reset();
        if (this.uic.cachingService.surveyData.question1) {
            $('.cbot-feedback__prompt .cbot-feedback__headline').html(this.uic.cachingService.surveyData.question1);
        }
        if (this.uic.cachingService.surveyData.question2) {
            $('#cbot-feedback__text-tnps-textarea').attr("placeholder", this.uic.cachingService.surveyData.question2);
        }
        this.elements.tnps.show();
        this.stopLoadingAnimation();
        this.resizeHeight();
    }
    initTNPSSurvey(surveyData) {
        if (!this.uic.widget.cachingService.surveyData) {
            this.uic.widget.cachingService.surveyData = {};
        }
        let cachedSurveyData = this.uic.widget.cachingService.surveyData;
        cachedSurveyData.feedback = surveyData.feedback;
        cachedSurveyData.question1 = surveyData.question1;
        cachedSurveyData.question2 = surveyData.question2;
        cachedSurveyData.questions = surveyData.questions;
        cachedSurveyData.hash = surveyData.hash;
        cachedSurveyData.apiUrl = surveyData.apiUrl;
        cachedSurveyData.surveyId = surveyData.surveyId;
        cachedSurveyData.useProbability = surveyData.useProbability;
        this.uic.widget.createTNPSSurveyFromCache();
    }
    hide() {
        this.elements.tnps.hide();
    }
    bootstrapScreen(chatWindowElement) {
        chatWindowElement.append(template);
        this.elements['widgetWindow'] = $('#chatbotWindow');
        this.elements['tnps'] = $('#cbot-feedback-tnps');
        this.elements['tnpsContentContainer'] = $('#cbot-feedback-tnps-content');
        this.elements['tnpsPrompt'] = $('.cbot-feedback__prompt');
        this.elements['tnpsNewQuestionButton'] = $('#cbot-feedback-tnps__button1');
        this.elements['tnpsSendButton'] = $('#cbot-feedback-tnps__button2');
        this.elements['tnpsFooter'] = $('#cbot-feedback-tnps').find('.cbot-feedback__footer');
        this.elements['tnpsFeedbackArea'] = $('#cbot-feedback-tnps__text-textarea');
        this.elements['tnpsFeedbackAreaContainer'] = $('.cbot-feedback__text');
        $('.cbot-feedback__scoreButton').click(() => {
            this.elements['tnpsSendButton'].removeAttr("disabled");
            this.elements['tnpsFeedbackArea'].removeAttr("readonly");
            $('input[name="cbot-feedback-radioG"]:not(:checked)+label').addClass('unchecked');
            this.showFeedbackArea(true);
        });
        this.elements['tnpsSendButton'].click(() => {
            this.uic.showScreen("thankyou");
            this.uic.widget.sendCustomNotice(new ScreenChangeNotice("thankyou", this.uic.widget.getWidgetApplicationId()));
            this.uic.widget.tnpsSurvey.answer($('input[type=radio]:checked + .cbot-feedback__scoreButton').text(), this.elements['tnpsFeedbackArea'].val(), this.uic.cachingService.surveyData.feedback).then(() => {
                this.sendAnalyticsEvent($('input[type=radio]:checked + .cbot-feedback__scoreButton').text(), this.elements['tnpsFeedbackArea'].val(), this.uic.cachingService.surveyData.feedback, false, true, null);
            }).catch((error) => {
                this.sendAnalyticsEvent($('input[type=radio]:checked + .cbot-feedback__scoreButton').text(), this.elements['tnpsFeedbackArea'].val(), null, false, true, "Error sending Survey Request: " + JSON.stringify(error));
            });
        });
        this.elements['tnpsNewQuestionButton'].click(() => {
            this.loadingAnimation();
            this.sendAnalyticsEvent(null, null, null, true, true, null);
            let trackingNotice = new TrackingNotice("chat", "Tnps_screen_new_question", "Tnps_screen_new_question");
            this.uic.widget.sendCustomNotice(trackingNotice).then(() => {
                this.uic.widget.silentlyRestartChatSession();
            });
        });
        // -----------------------------------------------------------------------------
        //                         DYNAMICALLY RESIZE CONTENT
        // -----------------------------------------------------------------------------
        $('.cbot-chatbotWindow').onload = this.resizeHeight();
        this.elements['loader'] = new LoadingElement(this.elements['tnpsFooter'], "tnps");
        this.reset();
        this.elements['tnpsFeedbackArea'].change(() => {
            if ($.trim(this.elements['tnpsFeedbackArea'].val()).length < 1) {
                this.elements['tnpsFeedbackArea'].addClass('is-empty');
            }
            else {
                this.elements['tnpsFeedbackArea'].removeClass('is-empty');
            }
        });
        this.elements['tnpsFeedbackArea'].focus(() => {
            if (!this.elements['tnpsFeedbackArea'].attr('readonly')) {
                this.elements['tnpsFeedbackArea'].addClass('animate');
            }
        });
    }
    stopLoadingAnimation() {
        this.elements['loader'].hide();
        this.elements['tnpsNewQuestionButton'].show();
        this.elements['tnpsSendButton'].show();
    }
    loadingAnimation() {
        this.elements['loader'].show();
        this.elements['tnpsNewQuestionButton'].hide();
        this.elements['tnpsSendButton'].hide();
    }
    resizeEvent() {
        this.resizeHeight();
        // Fix for Firefox to scroll to focused input
        if ($(':focus').get(0)) {
            $(':focus').get(0).scrollIntoView();
        }
    }
    showFeedbackArea(fadeIn) {
        if (fadeIn) {
            this.elements['tnpsFeedbackAreaContainer'].fadeIn();
        }
        else {
            this.elements['tnpsFeedbackAreaContainer'].show();
        }
        this.resizeHeight();
    }
    hideFeedbackArea() {
        this.elements['tnpsFeedbackAreaContainer'].hide();
        this.resizeHeight();
    }
}
